import { useState } from "react";
import Select from "react-select";

const AssignPackageModal = ({
  isOpen,
  onClose,
  assignCarriers,
  assignPackages,
  handleButtonSave
}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [selectedCarrier, setSelectedCarrier] = useState(null);
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [endDate, setEndDate] = useState("");
    if (!isOpen) return null;

    const calculateEndDate = (pkg) => {
        if (!pkg?.duration) return "";

        const today = new Date();
        const future = new Date(today);
        future.setDate(today.getDate() + pkg.duration);

        return future.toISOString().split("T")[0]; // yyyy-mm-dd
    };

    const handlePackageChange = (pkg) => {
        setSelectedPackage(pkg);
        const calculatedDate = calculateEndDate(pkg);
        setEndDate(calculatedDate);
    };

    const onSave = async () => {
        if (!selectedCarrier || !selectedPackage) {
            alert("Please select carrier and package");
            return;
        }
        try {
            setIsSaving(true);
            let rtn = await handleButtonSave({carrierId: selectedCarrier.value, packageId: selectedPackage.value, period: endDate});
            console.log("Saved:", rtn);
            onClose();
        } catch (err) {
            alert("Failed to save");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-3xl h-[70vh] max-h-[90vh] overflow-y-auto">
                
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl md:text-2xl font-bold">Assign Package to Carrier</h2>
                    <button onClick={onClose} className="text-xl text-gray-500">
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form className="space-y-5">

                    {/* Carrier */}
                    <div className="space-y-1">
                        <div className="font-semibold text-gray-600">Carrier</div>
                        <Select
                            name="trailer"
                            options={assignCarriers}
                            value={selectedCarrier}
                            onChange={setSelectedCarrier}
                            placeholder="Select Carrier"
                        />
                    </div>

                    {/* Package */}
                    <div className="space-y-1">
                        <div className="font-semibold text-gray-600">Package</div>
                        <Select
                            name="package"
                            options={assignPackages}
                            value={selectedPackage}
                            onChange={handlePackageChange}
                            placeholder="Select Package"
                        />
                    </div>

                    {selectedPackage && (
                        <div className="space-y-1">
                            <label className="block mb-1 font-semibold">Subscription End Date</label>
                            <input
                                type="date"
                                min={new Date().toISOString().split("T")[0]}
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                                onClick={(e) => e.target.showPicker()}
                                className="w-full border rounded px-3 py-2"
                            />
                        </div>
                    )}

                    <div className="space-y-1">
                        <button
                            type="button"
                            disabled={isSaving}
                            onClick={onSave}
                            className="bg-blue-600 text-white px-4 py-2 rounded flex items-center justify-center gap-2 disabled:opacity-50"
                        >
                            {isSaving ? (
                                <>
                                    <svg
                                        className="animate-spin h-5 w-5 text-white"
                                        viewBox="0 0 24 24"
                                    >
                                        <circle
                                        className="opacity-25"
                                        cx="12"
                                        cy="12"
                                        r="10"
                                        stroke="currentColor"
                                        strokeWidth="4"
                                        fill="none"
                                        />
                                        <path
                                        className="opacity-75"
                                        fill="currentColor"
                                        d="M4 12a8 8 0 018-8v8H4z"
                                        />
                                    </svg>
                                    Saving...
                                </>
                            ) : (
                                "Save"
                            )}
                        </button>
                    </div>

                </form>
            </div>
        </div>
    );
};

export default AssignPackageModal;

